import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect } from "react";
import { GET_BUSINESS_POS_ORDERS_ACTIVE, GET_GOOGLE_API_RECAPTCHA, GET_TINYMCE_KEY } from "./requests";
import { toast as showToast } from "react-toastify";
import { setActiveOrders } from "Redux/ConsumerSlice";
import { useDispatch } from "react-redux";

export const useGoogleRecaptchaApi = () => {
    const [getGoogleRecaptchaKey, { data: googleRecaptchaData, loading: recaptchaApiLoading }] =
        useLazyQuery(GET_GOOGLE_API_RECAPTCHA);

    useEffect(() => {
        getGoogleRecaptchaKey();
    }, []);

    return {
        googleRecaptchaData, recaptchaApiLoading
    };
}

export const useTinyMCEKey = () => {
    const [
        onLoadTinyMCEKey,
        { data }
    ] = useLazyQuery(GET_TINYMCE_KEY, {
        fetchPolicy: 'no-cache',
        onError: (error) => {
            showToast.error(error?.message || 'There was a problem. Data could not be loaded.');
        },
    });

    useEffect(() => {
        onLoadTinyMCEKey();
    }, []);

    const { getTinyMCEPublicKey: tinyMceKey } = data || {};
    return { tinyMceKey };
};

export const useOrdersNavHook = () => {
    const dispatch = useDispatch();

    const [getOrders, { loading: isActiveOrdersLoading, data }] = useMutation(
        GET_BUSINESS_POS_ORDERS_ACTIVE,
        {
            fetchPolicy: "no-cache",
            onCompleted: ({ getUserPosOrders }) => {
                if (!getUserPosOrders?.isSuccess) {
                    showToast.error(
                        getUserPosOrders?.errorMessage ||
                        "Something went wrong on fetching user POS orders"
                    );
                }
            },
            onError: (error) => {
                showToast.error(error?.message || "Failed to fetch user POS orders");
            },
        }
    );

    // set the active orders in the global state
    useEffect(() => {
        const activeOrdersCount = data?.getUserPosOrders?.totalCount;
        if (activeOrdersCount !== null && activeOrdersCount !== undefined) {
            dispatch(setActiveOrders(activeOrdersCount));
        }
    }, [data])

    return {
        isActiveOrdersLoading,
        getOrders,
    };
};